import { AxiosInstance, AxiosResponse } from 'axios';
import { SavedViewCreateDto } from './inputs/saved-view-create.input';
import { SavedViewUpdateDto } from './inputs/saved-view-update.input';
import { SavedViewBcfUploadUrlResponse } from './responses/saved-view-bcf-upload-url.response';
import { SavedViewDeleteResponse } from './responses/saved-view-delete.response';
import { SavedViewEntryResponse } from './responses/saved-view-entry.response';

export class SavedViewsModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async createBcfUploadUrl(): Promise<AxiosResponse<SavedViewBcfUploadUrlResponse>> {
    return await this.client.post('/saved-views/bcf-upload-url');
  }

  async createOne(dto: SavedViewCreateDto): Promise<AxiosResponse<SavedViewEntryResponse>> {
    return await this.client.post('/saved-views/', dto);
  }

  async updateOne(
    id: string,
    dto: SavedViewUpdateDto,
  ): Promise<AxiosResponse<SavedViewEntryResponse>> {
    return await this.client.put(`/saved-views/${id}`, dto);
  }

  async getOne(id: string): Promise<AxiosResponse<SavedViewEntryResponse>> {
    return await this.client.get(`/saved-views/${id}`);
  }

  async getManyByProject(projectEntryId: string): Promise<AxiosResponse<SavedViewEntryResponse[]>> {
    return await this.client.get(`/saved-views/`, { params: { projectEntryId } });
  }

  async deleteOne(id: string): Promise<AxiosResponse<SavedViewDeleteResponse>> {
    return await this.client.delete(`/saved-views/${id}`);
  }
}
